module.exports = __webpack_public_path__ + "d6a0c10b42d248210b9bf9d4a7766aee.svg";